import { render, staticRenderFns } from "./StudentsUpload.vue?vue&type=template&id=13c0a2c2"
import script from "./StudentsUpload.vue?vue&type=script&lang=js"
export * from "./StudentsUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports